var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"address-tab"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:index,class:_vm.isActive === index ? 'address-tab-div1' : 'address-tab-div2',on:{"click":function($event){return _vm.titletabClick(index)}}},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }